export const ANNOTATION_LABEL_FONT_WIDTH = 10;
export const realCharWidth = 8;
export const fudge2 = 3;
